import * as React from "react";

export const CalculationCorrectionIcon = (props) => (
  <svg
    className="icon"
    height="800px"
    viewBox="0 0 1024 1024"
    width="800px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 832a384 384 0 000-768 384 384 0 000 768zm48-176a48 48 0 11-96 0 48 48 0 0196 0zm-48-464a32 32 0 0132 32v288a32 32 0 01-64 0V288a32 32 0 0132-32z"
      fill="#000000"
    />
  </svg>
);
